export default function Contact() {
  return (
    <div className="fixed bottom-0 left-0 py-2 text-center bg-black text-white w-full">
      Pour ajouter/activer votre application à Deeplab <b>TEST</b>{" "}
      environnement, ou toute autre suggestion, contactez
      Liste-GRE-deeplab-admin@cea.fr.
    </div>
  );
}
